import { Input } from "@/components/ui/input";

export const inviteInputClass = "h-auto min-h-11 w-full min-w-0 rounded-none border-0 border-b border-[#0f0f10]/25 bg-transparent px-0 py-2.5 text-base font-normal text-[#0f0f10] shadow-none outline-none placeholder:text-[#0f0f10]/35 focus:border-[#0f0f10] focus:ring-0 focus-visible:ring-0 md:text-base";

export const InviteField = ({ name, label, className = "", ...props }) => (
  <label className={`block min-w-0 text-xs text-[color:var(--ink-3)] ${className}`} htmlFor={`invite-${name}`} data-testid={`invite-${name}-label`}>
    {label}
    <Input id={`invite-${name}`} name={name} className={inviteInputClass} data-testid={`invite-${name}-input`} {...props} />
  </label>
);